// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ff603f2","239":"c4f97f24","453":"339eb807","667":"f0028f73"}[chunkId] + ".chunk.js";
};